import { __module as e } from "./index775.js";
var s = e.exports, i;
function c() {
  return i ? e.exports : (i = 1, (function(u, p) {
    (function(a, r) {
      u.exports = r();
    })(s, (function() {
      return function(a, r) {
        r.prototype.weekYear = function() {
          var n = this.month(), o = this.week(), t = this.year();
          return o === 1 && n === 11 ? t + 1 : n === 0 && o >= 52 ? t - 1 : t;
        };
      };
    }));
  })(e), e.exports);
}
export {
  c as __require
};
